module.exports = __webpack_public_path__ + "static/5-feb5fd29b0f1528d639caf0f11a5c3ad.jpeg";